import * as types from './mutation-types'

export const fetchSociety = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('society').then((response) => {
      commit(types.SET_SOCIETY, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const createShopForSociety = ({ dispatch }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('society/shops', data).then((response) => {
      dispatch('fetchSociety')
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const switchShop = ({ dispatch }, shopId) => {
  return new Promise((resolve, reject) => {
    window.axios.patch(`society/shops/${shopId}/switch`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
